export const getDeliveryDates = async (axios, params) => {
  try {
    if (params) {
      return await axios.get('/api/basket/delivery-details/', { params })
    } else {
      return await axios.get('/api/basket/delivery-details/')
    }
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const getOrderDeliveryDate = async (axios, orderId, params) => {
  const toReturn = {
    errors: [],
  }

  try {
    const { data } = await axios.get(
      `/api/order/delivery_date_manager/${orderId}/`,
      {
        params,
      },
    )
    toReturn.dates = {
      min_delivery_date: data.min_date,
      min_ship_date: data.min_date,
      max_delivery_date: data.max_date,
      delivery_date: data.selected_date,
      ship_date: data.expected_ship_date,
      transit_dates: data.transit_days,
      exclude_dates: data.exclude_dates,
    }
  } catch (e) {
    console.error(e)
    toReturn.errors.push('Unable to retrieve order delivery date')
  }

  return toReturn
}

export const testOrderDeliveryDate = async (
  axios,
  orderId,
  params,
  customerServiceNumber,
  isAddressFlow = true,
) => {
  const toReturn = {
    dates: {},
    errors: [],
  }

  try {
    const { data } = await axios.get(
      `/api/order/delivery_date_manager/${orderId}/`,
      {
        params,
      },
    )
    toReturn.dates = {
      min_delivery_date: data.min_date,
      min_ship_date: data.min_date,
      max_delivery_date: data.max_date,
      delivery_date: data.selected_date,
      ship_date: data.expected_ship_date,
      transit_dates: data.transit_days,
      exclude_dates: data.exclude_dates,
    }
    if (!data.valid_delivery_date) {
      const errorDelivery = processInvalidDeliveryDate(isAddressFlow)
      toReturn.errors.push(errorDelivery)
    }
  } catch (e) {
    console.error(e)
    if (e.response && e.response.statusText.includes('change delivery date')) {
      toReturn.errors.push(
        `Your order is being prepared for shipment. If you need any assistance, please call Member Services at ${customerServiceNumber} 9am - 8pm ET Monday- Friday.`,
      )
    } else {
      toReturn.errors.push(
        `We're sorry, we cannot deliver on the date you selected. We have left the original delivery date unchanged. For assistance, please call Member Services at ${customerServiceNumber} 9am - 8pm ET Monday- Friday.`,
      )
    }
  }

  return toReturn
}

const processInvalidDeliveryDate = (isAddressFlow) => {
  let errorDelivery = 'Please select a new delivery date.'
  if (isAddressFlow) {
    errorDelivery =
      'Your current delivery date is not available for the requested address. ' +
      errorDelivery
  }
  return errorDelivery
}

export const setOrderDeliveryDate = async (
  axios,
  orderId,
  params,
  customerServiceNumber,
  isAddressFlow = true,
) => {
  const toReturn = {
    errors: [],
  }

  try {
    const { data } = await axios.put(
      `/api/order/delivery_date_manager/${orderId}/`,
      params,
    )
    toReturn.dates = {
      min_delivery_date: data.min_date,
      min_ship_date: data.min_date,
      max_delivery_date: data.max_date,
      delivery_date: data.selected_date,
      ship_date: data.expected_ship_date,
      transit_dates: data.transit_days,
      exclude_dates: data.exclude_dates,
    }
    if (!data.valid_delivery_date) {
      const errorDelivery = processInvalidDeliveryDate(isAddressFlow)
      toReturn.errors.push(errorDelivery)
    }
  } catch (e) {
    console.error(e)
    if (e.response && e.response.statusText.includes('change delivery date')) {
      toReturn.errors.push(
        `Your order is being prepared for shipment. If you need any assistance, please call Member Services at ${customerServiceNumber} 9am - 8pm ET Monday- Friday.`,
      )
    } else {
      toReturn.errors.push(
        `We're sorry, we cannot deliver on the date you selected. We have left the original delivery date unchanged. For assistance, please call Member Services at ${customerServiceNumber} 9am - 8pm ET Monday- Friday.`,
      )
    }
  }

  return toReturn
}
